exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-banners[data-v-ce910156] {\n  position: relative;\n  z-index: 1;\n}\n", ""]);

// exports
